import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithPopup } from 'firebase/auth';
import { auth, provider } from '../sign_in/Firebase';
import './SignUp.css';

export default function SignUp({ setIsLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showSignup, setShowSignup] = useState(true);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const data = { username, password, phone, email };

    try {
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await response.text();
      setMessage(result);

      if (result === "User registered successfully!") {
        const loginResponse = await fetch(`${API_BASE_URL}/auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        });

        const loginData = await loginResponse.json();

        if (loginData.success) {
          localStorage.setItem("token", loginData.token);
          localStorage.setItem("username", email);
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem("signupProgress", "businessCard");
          setIsLoggedIn(true); // ✅ ensure app knows we're logged in
          navigate("/BusinessCard");
        } else {
          setMessage("Registered, but login failed. Please log in manually.");
        }
      }
    } catch (error) {
      console.error("Signup error:", error);
      setMessage("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSignUp = async () => {
    setIsLoading(true);
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const data = {
        username: user.displayName,
        email: user.email,
        password: user.uid,
        phone: "0000000000"
      };

      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const resultText = await response.text();
      setMessage(resultText);

      if (resultText === "User registered successfully!") {
        const loginResponse = await fetch(`${API_BASE_URL}/auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: user.email, password: user.uid }),
        });

        const loginData = await loginResponse.json();

        if (loginData.success) {
          localStorage.setItem("token", loginData.token);
          localStorage.setItem("username", user.email);
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem("signupProgress", "businessCard");
          setIsLoggedIn(true); // ✅ ensure app knows we're logged in
          navigate("/BusinessCard");
        } else {
          setMessage("Registered with Google, but login failed.");
        }
      }
    } catch (error) {
      console.error("Google Sign Up error:", error);
      setMessage("Google Sign Up failed. Try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return showSignup ? (
    <div className="sign-up-page">
      <div className="sign-up-box">
        <h2 className="sign-up">Sign Up</h2>
        <form className="sign-up-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="form-row">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="form-row">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="form-row">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" className="submit-button" disabled={isLoading}>
            {isLoading ? "Registering..." : "Submit"}
          </button>

          {message && <p style={{ marginTop: "1rem", color: "green" }}>{message}</p>}

          <button
            type="button"
            className="google-button"
            onClick={handleGoogleSignUp}
            disabled={isLoading}
          >
            <img
              src="/Google_Icon.png"
              alt="Google logo"
              style={{ width: "20px", marginRight: "8px", verticalAlign: "middle" }}
            />
            {isLoading ? "Signing in with Google..." : "Sign Up with Google"}
          </button>
        </form>
      </div>
    </div>
  ) : null;
}
